module.exports = __webpack_public_path__ + "static/img/logo01.270a05d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo01.jpg
// module id = /hT5
// module chunks = 1